///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {
    import Dictionary = _.Dictionary;
    export class AlertsManagerEmployee extends DataTemplateBase implements IDataTemplate {
        protected _employeeCategories: EmployeeCategoriesCollection;
        protected _employees: AlertsManagerEmployeeCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        private _required: boolean;

        set required(value: boolean) {
            this._required = value;
            this.updateRequiredValidator(value, this.collection);
        }

        get required(): boolean {
            return this._required;
        }
        get collection() {
            return this._employeeCategories;
        }

        get leafCollection() {
            return this._employees;
        }

        get totalSelectedCount(): number {
            return this._employees.value.length;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[0]];
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this._employees = new AlertsManagerEmployeeCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: <ModelValueType[]>options.defaultValue,
                smartMoverHidden: () => this.smartMoverHidden
            })
            this._employeeCategories = new EmployeeCategoriesCollection(this.model[properties[1]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this._employees.setParentCollection(this._employeeCategories, CoreEmployeeToCategoryStrategy);

            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES' }, this)
            ];
            this._employees.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_ALL_EMPLOYEES';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';

        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this._employees.setWatchers(scope);
        }
    }
}